const apiUrl = process.env.REACT_APP_API_URL;

export const uploadItemFiles = async(itemId, files) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/files/uploadFiles/${itemId}`;
    
    const formData = new FormData();
    
    // Agregar todos los archivos al FormData
    Array.from(files).forEach(file => {
        formData.append('files', file);
    });
    
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Authorization': `Bearer ${token}`,
            // NO incluir Content-Type, el browser lo establece automáticamente con boundary para multipart/form-data
        },
        body: formData
    };
    
    try {
        const response = await fetch(url, requestOptions);
        return await response.json(); 
    } catch (error) {
        console.error('Error al subir archivos:', error);
        return { result: false };
    }
}

export const getItemAttachments = async(itemId) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/files/getAttachments/${itemId}`;
    
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    };
    
    try {
        const response = await fetch(url, requestOptions);
        const data = await response.json();
        
        // El backend retorna { result: true, data: [...] }
        if (data.result && Array.isArray(data.data)) {
            return data.data;
        }
        
        // Si retorna directamente un array
        if (Array.isArray(data)) {
            return data;
        }
        
        return [];
    } catch (error) {
        console.error('Error al obtener archivos:', error);
        return [];
    }
}

export const deleteAttachment = async(attachmentId) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/files/deleteAttachment/${attachmentId}`;
    
    const requestOptions = {
        method: 'DELETE',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    };
    
    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        console.error('Error al eliminar archivo:', error);
        return { result: false };
    }
}
